<app-ai-message *ngFor="let message of messages" [model]="message" [avatarSize]="avatarSize"></app-ai-message>
